import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { formatPhoneNumber } from '../../utils'
import { Colors } from '../../styles/theme'
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import SyncIcon from '@mui/icons-material/Sync';
import { usePreferences } from 'hooks/usePreferences';
import { formatPhoneForDisplay } from '../../utils/phoneUtils';
import { formatDateWithPreferences } from '../../utils/dateFormatUtils';

function CustomerInfobar({ customerData, loadCustomer }) {
    const { preferences: businessPreferences } = usePreferences();

    return (
        <Box display="flex" alignItems="center">
            <Box display="flex" alignItems="center">
                <Typography variant="h4" sx={{ color: Colors.dim_grey, textTransform: "capitalize", mr: 2 }}>
                    {customerData.customer.fullName}
                </Typography>
                {
                    loadCustomer && (<IconButton onClick={() => loadCustomer(customerData.customer.id)}>
                        <Tooltip title="Refresh">
                            <SyncIcon fontSize="small" sx={{ ml: 1, color: Colors.dim_grey }} />
                        </Tooltip>
                    </IconButton>)
                }
            </Box>
            {
                customerData.customer.birthdate &&
                <>
                    <CalendarTodayIcon sx={{ fontSize: '0.75rem', mr: 1, color: Colors.dim_grey }} />
                    <Typography variant="caption" sx={{ color: Colors.dim_grey, textTransform: "capitalize" }}>
                        {formatDateWithPreferences(customerData.customer.birthdate, businessPreferences)}
                    </Typography>
                    <Typography variant="caption" sx={{ ml: 1, color: Colors.dim_grey, textTransform: "capitalize" }}>
                        ({customerData.customer.age} years)
                    </Typography>
                </>

            }
            <Typography component={"span"} variant="caption" sx={{ color: Colors.dim_grey, textTransform: "capitalize" }}>
                {customerData.customer.fullAddress}
            </Typography>
            <LocalPhoneIcon fontSize="small" sx={{ fontSize: '0.75rem', ml: 1, color: Colors.dim_grey }} />
            <Typography component={"span"} variant="caption" sx={{ ml: 1, color: Colors.dim_grey }}>
                {formatPhoneForDisplay(customerData.customer.mobile, businessPreferences).displayText}
            </Typography>
        </Box>
    )
}

export default CustomerInfobar